<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table
        class="c-indicator c-indicator-w-100 okpd-products-table"
        :class="{ 'okpd-products-table--readonly': isReadOnly }"
        v-if="
          project.PROJECT_OKPD_PRODUCTS &&
            project.PROJECT_OKPD_PRODUCTS.items &&
            project.PROJECT_OKPD_PRODUCTS.items.length > 0
        "
      >
        <thead>
          <tr>
            <th class="okpd-col-num">№ п/п</th>
            <th class="okpd-col-code">ОКПД</th>
            <th class="okpd-col-list" v-if="!isTypeProductHidden">Перечень</th>
            <th>Продукция</th>
            <th v-if="showTnVed">Таможенное наименование товара</th>
            <th class="okpd-col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in project.PROJECT_OKPD_PRODUCTS.items">
            <tr
              v-if="editingIndex !== index"
              :key="'view-' + index"
              :class="{ 'okpd-row-error': hasRowError(index) }"
            >
              <td class="okpd-col-num">{{ index + 1 }}</td>
              <td class="okpd-col-code">{{ getMinOkpdCode(item) }}</td>
              <td class="okpd-col-list" v-if="!isTypeProductHidden">{{ getTypeProductName(item.UF_SP_PROJECT_OKPD_TYPE_PRODUCT) }}</td>
              <td>{{ item.UF_PRODUCT }}</td>
              <td v-if="showTnVed">{{ item.UF_TN_VED }}</td>
              <td class="okpd-col-actions">
                <a
                  href="javascript:void(0)"
                  class="okpd-icon-btn okpd-icon-btn--edit"
                  title="Редактировать"
                  @click="editItem(index)"
                  v-if="!isReadOnly"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/>
                  </svg>
                </a>
                <a
                  href="javascript:void(0)"
                  class="okpd-icon-btn okpd-icon-btn--delete"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                  v-if="!isReadOnly"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-else :key="'edit-' + index">
              <td class="okpd-col-num">{{ index + 1 }}</td>
              <td>
                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_CLASS_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Класс:</label></p>
                  <select
                    v-model="item.UF_OKPD_CLASS_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_CLASS_ID'),
                        changeClass(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in directory.tree_sp_infoproduction"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-text="dirItem.CODE + ' ' + dirItem.NAME"
                      v-if="
                        isShowClassByProgram(dirItem) &&
                          (!isMarkingOnlyClassCode(dirItem.CODE) ||
                            $parent.$parent.getProgramCode() === 'lekarstva') &&
                          ((dirItem.CODE !== '8' &&
                            dirItem.CODE !== '38' &&
                            $parent.$parent.getProgramCode() == 'lekarstva') ||
                            (dirItem.CODE !== 8 &&
                              (dirItem.CODE !== '11' ||
                                isLizingSpecializedManufacturing()) &&
                              dirItem.CODE !== '38' &&
                              dirItem.CODE !== '19' &&
                              $parent.$parent.getProgramCode() != 'lekarstva'))
                      "
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_CLASS_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_PODCLASS_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Подкласс:</label></p>
                  <select
                    v-model="item.UF_OKPD_PODCLASS_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_PODCLASS_ID'),
                        changePodClass(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdPodclass(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-if="isShowPodClassByProgram(dirItem)"
                      v-text="dirItem.CODE + ' ' + dirItem.NAME"
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_PODCLASS_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_GROUP_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Группа:</label></p>
                  <select
                    v-model="item.UF_OKPD_GROUP_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_GROUP_ID'),
                        changeGroup(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdGroup(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-text="dirItem.CODE + ' ' + dirItem.NAME"
                      v-if="isShowGroupClassByProgram(dirItem)"
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_GROUP_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_PODGROUP_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Подгруппа:</label></p>
                  <select
                    v-model="item.UF_OKPD_PODGROUP_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_PODGROUP_ID'),
                        changePodGroup(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdPodGroup(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-if="isShowPodGroupClassByProgram(dirItem)"
                      v-text="dirItem.CODE + ' ' + dirItem.NAME"
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_PODGROUP_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_VID_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Вид:</label></p>
                  <select
                    v-model="item.UF_OKPD_VID_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_VID_ID'),
                        changeVid(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdVidclass(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-if="isShowVidClassByProgram(dirItem)"
                      v-text="dirItem.CODE + ' ' + dirItem.NAME"
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_VID_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_CATEGORY_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Категория:</label></p>
                  <select
                    v-model="item.UF_OKPD_CATEGORY_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="
                      removeError(index, 'UF_OKPD_CATEGORY_ID'),
                        changeCategory(item)
                    "
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdCategoryclass(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-if="isShowCategoriyaByProgram(dirItem, item)"
                      v-text="
                        (dirItem.CODE != 'no' ? dirItem.CODE : '') +
                          ' ' +
                          dirItem.NAME
                      "
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_CATEGORY_ID") }}
                  </div>
                </div>

                <div
                  v-bind:class="{
                    'has-error': hasError(index, 'UF_OKPD_PODCATEGORY_ID')
                  }"
                >
                  <p class="content-s-2-label"><label>Подкатегория:</label></p>
                  <select
                    v-model="item.UF_OKPD_PODCATEGORY_ID"
                    class="sel-dropdown i-main-style i-wid-100"
                    v-on:change="removeError(index, 'UF_OKPD_PODCATEGORY_ID')"
                    :disabled="isReadOnly"
                  >
                    <option value=""></option>
                    <option
                      v-for="dirItem in okpdPodCategoryclass(item)"
                      v-bind:value="dirItem.ID"
                      v-bind:key="dirItem.ID"
                      v-if="isMarkerOkpdAllowed(dirItem.CODE)"
                      v-text="
                        (dirItem.CODE != 'no' ? dirItem.CODE : '') +
                          ' ' +
                          dirItem.NAME
                      "
                    ></option>
                  </select>
                  <div class="error-text">
                    {{ errorText(index, "UF_OKPD_PODCATEGORY_ID") }}
                  </div>
                </div>
              </td>
              <td
                v-if="!isTypeProductHidden"
                v-bind:class="{
                  'has-error': hasError(index, 'UF_SP_PROJECT_OKPD_TYPE_PRODUCT')
                }"
              >
                <select
                  v-model="item.UF_SP_PROJECT_OKPD_TYPE_PRODUCT"
                  class="sel-dropdown i-main-style i-wid-100"
                  v-on:change="
                    removeError(index, 'UF_SP_PROJECT_OKPD_TYPE_PRODUCT')
                  "
                  :disabled="isReadOnly"
                >
                  <option value=""></option>
                  <option
                    v-for="dirItem in directory.sp_project_okpd_products"
                    v-bind:value="dirItem.ID"
                    v-bind:key="dirItem.ID"
                    v-text="dirItem.NAME"
                  ></option>
                </select>
                <div class="error-text">
                  {{ errorText(index, "UF_SP_PROJECT_OKPD_TYPE_PRODUCT") }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'has-error': hasError(index, 'UF_PRODUCT')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_PRODUCT"
                  maxlength="500"
                  style="width: 96%"
                  @keyup="removeError(index, 'UF_PRODUCT')"
                  :disabled="isReadOnly"
                />
                <div class="error-text">
                  {{ errorText(index, "UF_PRODUCT") }}
                </div>
              </td>
              <td
                v-if="showTnVed"
                v-bind:class="{
                  'has-error': hasError(index, 'UF_TN_VED')
                }"
              >
                <select
                  v-model.trim="item.UF_TN_VED"
                  class="sel-dropdown i-main-style i-wid-100"
                  v-on:change="removeError(index, 'UF_TN_VED')"
                  :disabled="isReadOnly"
                >
                  <option value=""></option>
                  <option
                    v-for="tn in tnved()"
                    v-bind:value="tn.trim()"
                    v-bind:key="tn"
                    v-text="tn"
                  ></option>
                </select>
                <div class="error-text">
                  {{ errorText(index, "UF_TN_VED") }}
                </div>
              </td>
              <td class="okpd-col-actions">
                <a
                  href="javascript:void(0)"
                  class="okpd-icon-btn okpd-icon-btn--save"
                  title="Сохранить"
                  @click="saveItem(index)"
                  v-if="!isReadOnly"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                  </svg>
                </a>
                <a
                  href="javascript:void(0)"
                  class="okpd-icon-btn okpd-icon-btn--cancel"
                  title="Отмена"
                  @click="cancelEdit(index)"
                  v-if="!isReadOnly"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/>
                  </svg>
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="add-row" v-if="!isReadOnly">
        <a class="link-add-row" v-on:click="addItem">Добавить продукцию</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "ProjectOkpdProducts",
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editingIndex: null,
      listErrors: {},
      newItemIndex: null
    };
  },
  async created() {
    // Память предыдущих кодов ОКПД по каждой строке: ключ — сам объект строки
    // (стабильная ссылка), значение — снимок кодов перед очисткой. Нужна, чтобы
    // при возврате маркируемой продукции к подходящему значению восстановить коды.
    // Храним вне data, чтобы Vue не делал Map реактивным.
    this.okpdBackups = new Map();

    // Аналогичная память для таможенного наименования товара (ТН ВЭД): снимок
    // UF_TN_VED по каждой строке, чтобы восстановить его при возврате к
    // маркируемой продукции, в списке ТН ВЭД которой это значение присутствует.
    this.tnVedBackups = new Map();

    await this.$store.dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"]);
    await this.$store.dispatch(FETCH_DIRECTORY, ["tree/industry"]);
    await this.$store.dispatch(FETCH_DIRECTORY, [
      "sp_purchased_equipment_lizing"
    ]);
    await this.$store.dispatch(FETCH_DIRECTORY, ["sp_project_okpd_products"]);
    await this.$store.dispatch(FETCH_DIRECTORY, ["marker_products"]);

    if (
      !this.project.PROJECT_OKPD_PRODUCTS ||
      typeof this.project.PROJECT_OKPD_PRODUCTS.items === "undefined"
    ) {
      Vue.set(this.project, "PROJECT_OKPD_PRODUCTS", { items: [] });
    }
  },
  watch: {
    // При смене маркируемой продукции сносим из таблицы строки, чьи коды ОКПД
    // не соответствуют новому выбору (доработка связки маркируемой продукции и ОКПД).
    "project.UF_MARKER_PRODUCTS_ID"() {
      this.syncOkpdCodesWithMarker();
    }
  },
  computed: {
    serverErrors() {
      if (this.$parent && this.$parent.$parent) {
        return this.$parent.$parent.projectOkpdProductsErrors || {};
      }
      return {};
    },
    isReadOnly() {
      if (this.readonly) return true;
      if (this.$parent && this.$parent.$parent) {
        return !!this.$parent.$parent.projectDisabled;
      }
      return false;
    },
    isTypeProductHidden() {
      // Программы, для которых столбец "Перечень" неактуален и скрывается:
      // "Маркировка товаров" (код "lekarstva") и
      // "Обеспечение мобилизационных нужд" (код "providing_mobilization_needs").
      if (!this.$parent || !this.$parent.$parent) return false;
      let code = this.$parent.$parent.getProgramCode();
      return code === "lekarstva" || code === "providing_mobilization_needs";
    },
    isTypeProductOptional() {
      // "Проекты развития" (evolution) + направление финансирования "Повышение
      // уровня автоматизации и цифровизации производств": столбец "Перечень"
      // показываем, но обязательным не считаем (бэкенд разрешает сохранение с NULL).
      if (!this.$parent || !this.$parent.$parent) return false;
      if (this.$parent.$parent.getProgramCode() !== "evolution") return false;
      let id = this.$parent.project.UF_DIRECTION_FINANCING_ID;
      if (!(id > 0)) return false;
      let dir = (this.directory.sp_direction_financing || []).find(function(
        item
      ) {
        return item.ID == id;
      });
      return (
        !!dir && dir.CODE === "increasing_level_of_automation_and_digitalization"
      );
    },
    showTnVed() {
      return !!(
        this.$parent &&
        this.$parent.project &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.VERSION_MARKER_PRODUCTS > 1 &&
        this.$parent.$parent &&
        this.$parent.$parent.getProgramCode() === "lekarstva" &&
        this.$parent.project.UF_MARKER_PRODUCTS_ID > 0
      );
    },
    ...mapGetters(["directory", "project"])
  },
  methods: {
    tnved() {
      // Сравнение через parseInt: ID справочника marker_products приходит строкой
      // (directory сериализуется без JSON_NUMERIC_CHECK), а UF_MARKER_PRODUCTS_ID — числом.
      let t = this.directory.marker_products.filter(
        c => parseInt(c.ID) === parseInt(this.$parent.project.UF_MARKER_PRODUCTS_ID)
      );
      if (t.length > 0) {
        return t[0].TN_VED;
      }
      return [];
    },
    markerOkpdAllowedCodes() {
      // Коды ОКПД2, разрешённые для выбранной маркируемой продукции (пункт 4).
      // Пустой результат означает «ограничения нет» — показываем все коды
      // (товар без заданных кодов, либо маркируемая продукция не выбрана).
      let markerId = this.$parent.project.UF_MARKER_PRODUCTS_ID;
      if (!markerId || parseInt(markerId) <= 0) {
        return [];
      }
      let t = this.directory.marker_products.filter(
        c => parseInt(c.ID) === parseInt(markerId)
      );
      if (t.length === 0 || !Array.isArray(t[0].OKPD2)) {
        return [];
      }
      return t[0].OKPD2.map(code => String(code).replace(/\D/g, "")).filter(
        code => code !== ""
      );
    },
    isMarkerOkpdAllowed(code) {
      // Ограничение кодов ОКПД по выбранной маркируемой продукции: показываем код,
      // если он либо предок разрешённого кода (путь к нему), либо его потомок
      // (детализация). ОКПД2 — иерархия по цифровому префиксу, поэтому сравниваем
      // коды без разделителей (как в isMachineToolOkpdAllowed). Если для товара
      // коды не заданы — ограничения нет.
      let allowed = this.markerOkpdAllowedCodes();
      if (allowed.length === 0) {
        return true;
      }
      if (code === null || typeof code === "undefined") {
        return true;
      }
      let norm = String(code).replace(/\D/g, "");
      if (norm === "") {
        // узлы без кода (CODE === "no") — потомки уже отфильтрованного родителя
        return true;
      }
      return allowed.some(function(a) {
        return norm.indexOf(a) === 0 || a.indexOf(norm) === 0;
      });
    },
    syncOkpdCodesWithMarker() {
      // Синхронизация кодов ОКПД с выбранной маркируемой продукцией:
      //  - если коды строки не подходят под новый выбор — сохраняем их снимок
      //    в okpdBackups и очищаем (саму строку и поля продукция/ТН ВЭД оставляем);
      //  - если у строки коды очищены, но в памяти есть снимок, и эти коды снова
      //    подходят под текущий выбор — восстанавливаем их.
      if (
        !this.project.PROJECT_OKPD_PRODUCTS ||
        !Array.isArray(this.project.PROJECT_OKPD_PRODUCTS.items)
      ) {
        return;
      }
      let okpdFields = [
        "UF_OKPD_CLASS_ID",
        "UF_OKPD_PODCLASS_ID",
        "UF_OKPD_GROUP_ID",
        "UF_OKPD_PODGROUP_ID",
        "UF_OKPD_VID_ID",
        "UF_OKPD_CATEGORY_ID",
        "UF_OKPD_PODCATEGORY_ID"
      ];
      this.project.PROJECT_OKPD_PRODUCTS.items.forEach(item => {
        let code = this.getMinOkpdCode(item);
        if (code !== "") {
          // В строке есть коды: чистим их, если они больше не подходят.
          if (!this.isMarkerOkpdAllowed(code)) {
            let backup = {};
            okpdFields.forEach(field => {
              backup[field] = item[field];
            });
            this.okpdBackups.set(item, backup);
            okpdFields.forEach(field => {
              item[field] = "";
            });
          }
        } else {
          // В строке кодов нет: пробуем восстановить ранее очищенные, если они
          // снова подходят под текущую маркируемую продукцию.
          let backup = this.okpdBackups.get(item);
          if (backup && this.isMarkerOkpdAllowed(this.getMinOkpdCode(backup))) {
            okpdFields.forEach(field => {
              item[field] = backup[field];
            });
            this.okpdBackups.delete(item);
          }
        }

        // ТН ВЭД зависит напрямую от выбранной маркируемой продукции (список из
        // marker_products[].TN_VED). Лечим его независимо от кодов ОКПД:
        //  - если значение строки больше не входит в список нового выбора —
        //    сохраняем снимок в tnVedBackups и очищаем;
        //  - если поле очищено, но в памяти есть снимок, и он снова подходит под
        //    текущий выбор — восстанавливаем.
        let tnVed = item.UF_TN_VED;
        if (tnVed && String(tnVed).trim() !== "") {
          if (!this.isMarkerTnVedAllowed(tnVed)) {
            this.tnVedBackups.set(item, tnVed);
            item.UF_TN_VED = "";
          }
        } else {
          let tnBackup = this.tnVedBackups.get(item);
          if (
            typeof tnBackup !== "undefined" &&
            this.isMarkerTnVedAllowed(tnBackup)
          ) {
            item.UF_TN_VED = tnBackup;
            this.tnVedBackups.delete(item);
          }
        }
      });
    },
    isMarkerTnVedAllowed(value) {
      // Допустимо ли значение ТН ВЭД для текущей маркируемой продукции.
      // Пустое значение и отсутствие списка ТН ВЭД трактуем как «ограничения нет».
      if (value === null || typeof value === "undefined") {
        return true;
      }
      let norm = String(value).trim();
      if (norm === "") {
        return true;
      }
      let allowed = this.tnved();
      if (!Array.isArray(allowed) || allowed.length === 0) {
        return true;
      }
      return allowed.some(a => String(a).trim() === norm);
    },
    okpdPodclass(item) {
      if (!item.UF_OKPD_CLASS_ID || item.UF_OKPD_CLASS_ID < 1) {
        return [];
      }
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.ID === item.UF_OKPD_CLASS_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdGroup(item) {
      if (!item.UF_OKPD_PODCLASS_ID || item.UF_OKPD_PODCLASS_ID < 1) {
        return [];
      }
      let t = this.okpdPodclass(item).filter(
        c => c.ID === item.UF_OKPD_PODCLASS_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdPodGroup(item) {
      if (!item.UF_OKPD_GROUP_ID || item.UF_OKPD_GROUP_ID < 1) {
        return [];
      }
      let t = this.okpdGroup(item).filter(c => c.ID === item.UF_OKPD_GROUP_ID);
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdVidclass(item) {
      if (!item.UF_OKPD_PODGROUP_ID || item.UF_OKPD_PODGROUP_ID < 1) {
        return [];
      }
      let t = this.okpdPodGroup(item).filter(
        c => c.ID === item.UF_OKPD_PODGROUP_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdCategoryclass(item) {
      if (!item.UF_OKPD_VID_ID || item.UF_OKPD_VID_ID < 1) {
        return [];
      }
      let t = this.okpdVidclass(item).filter(
        c => c.ID === item.UF_OKPD_VID_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    okpdPodCategoryclass(item) {
      if (!item.UF_OKPD_CATEGORY_ID || item.UF_OKPD_CATEGORY_ID < 1) {
        return [];
      }
      let t = this.okpdCategoryclass(item).filter(
        c => c.ID === item.UF_OKPD_CATEGORY_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    findOkpdNode(list, id) {
      if (!list || !id) return null;
      for (let i = 0; i < list.length; i++) {
        if (list[i].ID === id) return list[i];
        if (list[i].CHILD && list[i].CHILD.length) {
          let sub = this.findOkpdNode(list[i].CHILD, id);
          if (sub) return sub;
        }
      }
      return null;
    },
    getMinOkpdCode(item) {
      let order = [
        "UF_OKPD_PODCATEGORY_ID",
        "UF_OKPD_CATEGORY_ID",
        "UF_OKPD_VID_ID",
        "UF_OKPD_PODGROUP_ID",
        "UF_OKPD_GROUP_ID",
        "UF_OKPD_PODCLASS_ID",
        "UF_OKPD_CLASS_ID"
      ];
      for (let i = 0; i < order.length; i++) {
        let id = item[order[i]];
        if (id && id > 0) {
          let node = this.findOkpdNode(
            this.directory.tree_sp_infoproduction,
            id
          );
          if (node && node.CODE && node.CODE !== "no") {
            return node.CODE;
          }
        }
      }
      return "";
    },
    getTypeProductName(id) {
      if (!id) return "";
      let list = this.directory.sp_project_okpd_products || [];
      let t = list.filter(c => c.ID === id);
      if (t.length > 0) return t[0].NAME;
      return "";
    },
    addItem() {
      if (
        !this.project.PROJECT_OKPD_PRODUCTS ||
        typeof this.project.PROJECT_OKPD_PRODUCTS.items === "undefined"
      ) {
        Vue.set(this.project, "PROJECT_OKPD_PRODUCTS", { items: [] });
      }
      this.project.PROJECT_OKPD_PRODUCTS.items.push({
        UF_OKPD_CLASS_ID: "",
        UF_OKPD_PODCLASS_ID: "",
        UF_OKPD_GROUP_ID: "",
        UF_OKPD_PODGROUP_ID: "",
        UF_OKPD_VID_ID: "",
        UF_OKPD_CATEGORY_ID: "",
        UF_OKPD_PODCATEGORY_ID: "",
        UF_SP_PROJECT_OKPD_TYPE_PRODUCT: "",
        UF_PRODUCT: "",
        UF_TN_VED: ""
      });
      this.newItemIndex = this.project.PROJECT_OKPD_PRODUCTS.items.length - 1;
      this.editingIndex = this.newItemIndex;
    },
    editItem(index) {
      this.editingIndex = index;
      this.newItemIndex = null;
    },
    deleteItem(index) {
      this.project.PROJECT_OKPD_PRODUCTS.items.splice(index, 1);
      if (this.editingIndex === index) {
        this.editingIndex = null;
        this.newItemIndex = null;
      } else if (this.editingIndex !== null && this.editingIndex > index) {
        this.editingIndex = this.editingIndex - 1;
      }
    },
    saveItem(index) {
      let item = this.project.PROJECT_OKPD_PRODUCTS.items[index];
      let errors = {};
      if (!item.UF_OKPD_CLASS_ID) {
        errors["UF_OKPD_CLASS_ID"] = "Обязательное поле";
      }
      if (
        !this.isTypeProductHidden &&
        !this.isTypeProductOptional &&
        !item.UF_SP_PROJECT_OKPD_TYPE_PRODUCT
      ) {
        errors["UF_SP_PROJECT_OKPD_TYPE_PRODUCT"] = "Обязательное поле";
      }
      if (!item.UF_PRODUCT || !String(item.UF_PRODUCT).trim()) {
        errors["UF_PRODUCT"] = "Обязательное поле";
      }
      if (this.showTnVed && (!item.UF_TN_VED || !String(item.UF_TN_VED).trim())) {
        errors["UF_TN_VED"] = "Обязательное поле";
      }
      if (Object.keys(errors).length > 0) {
        Vue.set(this.listErrors, index, errors);
        return;
      }
      Vue.delete(this.listErrors, index);
      this.editingIndex = null;
      this.newItemIndex = null;
    },
    cancelEdit(index) {
      if (this.newItemIndex === index) {
        this.project.PROJECT_OKPD_PRODUCTS.items.splice(index, 1);
      }
      Vue.delete(this.listErrors, index);
      this.editingIndex = null;
      this.newItemIndex = null;
    },
    hasError(index, field) {
      if (
        this.listErrors[index] &&
        typeof this.listErrors[index][field] !== "undefined"
      ) {
        return true;
      }
      let srv = this.serverErrors;
      return !!(srv[index] && typeof srv[index][field] !== "undefined");
    },
    errorText(index, field) {
      if (
        this.listErrors[index] &&
        typeof this.listErrors[index][field] !== "undefined"
      ) {
        return this.listErrors[index][field];
      }
      let srv = this.serverErrors;
      if (srv[index] && typeof srv[index][field] !== "undefined") {
        return srv[index][field];
      }
      return "";
    },
    removeError(index, field) {
      if (
        this.listErrors[index] &&
        typeof this.listErrors[index][field] !== "undefined"
      ) {
        Vue.delete(this.listErrors[index], field);
      }
      let srv = this.serverErrors;
      if (srv[index] && typeof srv[index][field] !== "undefined") {
        Vue.delete(srv[index], field);
      }
    },
    hasRowError(index) {
      if (
        this.listErrors[index] &&
        Object.keys(this.listErrors[index]).length > 0
      ) {
        return true;
      }
      let srv = this.serverErrors;
      return !!(srv[index] && Object.keys(srv[index]).length > 0);
    },
    changeClass(item) {
      item.UF_OKPD_PODCLASS_ID = "";
      item.UF_OKPD_GROUP_ID = "";
      item.UF_OKPD_PODGROUP_ID = "";
      item.UF_OKPD_VID_ID = "";
      item.UF_OKPD_CATEGORY_ID = "";
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    changePodClass(item) {
      item.UF_OKPD_GROUP_ID = "";
      item.UF_OKPD_PODGROUP_ID = "";
      item.UF_OKPD_VID_ID = "";
      item.UF_OKPD_CATEGORY_ID = "";
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeGroup(item) {
      item.UF_OKPD_PODGROUP_ID = "";
      item.UF_OKPD_VID_ID = "";
      item.UF_OKPD_CATEGORY_ID = "";
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    changePodGroup(item) {
      item.UF_OKPD_VID_ID = "";
      item.UF_OKPD_CATEGORY_ID = "";
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeVid(item) {
      item.UF_OKPD_CATEGORY_ID = "";
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    changeCategory(item) {
      item.UF_OKPD_PODCATEGORY_ID = "";
    },
    isMachineToolDirection() {
      // Ограничение кодов продукции для программ "Проекты развития" (evolution)
      // и "Проекты РФРП / Проекты развития" (regfond) при направлении
      // финансирования "Производство станкоинструментальной продукции и роботов"
      let programCode = this.$parent.$parent.getProgramCode();
      if (programCode !== "evolution" && programCode !== "regfond") {
        return false;
      }
      if (
        !this.$parent.project.UF_DIRECTION_FINANCING_ID ||
        this.$parent.project.UF_DIRECTION_FINANCING_ID <= 0
      ) {
        return false;
      }
      let spDirectionFinanсing = this.directory.sp_direction_financing.filter(
        c => c.ID === this.$parent.project.UF_DIRECTION_FINANCING_ID
      );
      return (
        spDirectionFinanсing.length > 0 &&
        spDirectionFinanсing[0].CODE === "production_machine_tool_products_v2"
      );
    },
    isMachineToolOkpdAllowed(code) {
      // Разрешённые коды ОКПД для направления "Производство
      // станкоинструментальной продукции и роботов":
      //   25.73        — Инструмент
      //   26.51.66.190 — Инструменты, приборы и машины для измерения или
      //                  контроля прочие, не включенные в другие группировки
      //   28.4         — Оборудование металлообрабатывающее и станки
      //   28.99.39.200 — Промышленные роботы и робототехнические устройства
      // ОКПД2 — иерархия по цифровому префиксу (каждый уровень добавляет цифры),
      // поэтому сравниваем коды без разделителей. Показываем код, если он либо
      // предок разрешённого кода (путь к нему), либо его потомок (детализация).
      if (code === null || typeof code === "undefined") {
        return true;
      }
      let norm = String(code).replace(/\D/g, "");
      if (norm === "") {
        // узлы без кода (CODE === "no") — потомки уже отфильтрованного родителя
        return true;
      }
      let allowed = ["2573", "265166190", "284", "289939200"];
      return allowed.some(function(a) {
        return norm.indexOf(a) === 0 || a.indexOf(norm) === 0;
      });
    },
    isShowClassByProgram(dirItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowClass = false;
      let spDirectionFinanсing = [];
      if (
        this.$parent.project.UF_DIRECTION_FINANCING_ID &&
        this.$parent.project.UF_DIRECTION_FINANCING_ID > 0
      ) {
        spDirectionFinanсing = this.directory.sp_direction_financing.filter(
          c => c.ID === this.$parent.project.UF_DIRECTION_FINANCING_ID
        );
      }

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0 || indistry[0].CODE == null) {
            isShowClass = true;
          } else if (this.in_array(indistry[0].CODE, [35])) {
            isShowClass = true;
          } else if (
            indistry[0].CODE.length > 2 &&
            indistry[0].CODE.indexOf(";", 0) >= 0
          ) {
            let arrCode = indistry[0].CODE.split(";");
            if (this.in_array(dirItem.CODE, arrCode)) {
              isShowClass = true;
            }
          } else {
            let codeFind = indistry[0].CODE;
            if (indistry[0].CODE == 34) {
              codeFind = 32;
            } else if (indistry[0].CODE == "28_1") {
              codeFind = 28;
            } else if (indistry[0].CODE == "31_1") {
              codeFind = 31;
            } else if (indistry[0].CODE == "30_1") {
              codeFind = 30;
            } else if (indistry[0].CODE == 36) {
              codeFind = [10, 20];
            }

            if (Array.isArray(codeFind)) {
              if (this.in_array(dirItem.CODE, codeFind)) {
                isShowClass = true;
              }
            } else if (dirItem.CODE == codeFind) {
              isShowClass = true;
            }
          }
        } else {
          isShowClass = true;
        }
      } else if (
        this.$parent.project.UF_DIRECTION_FINANCING_ID &&
        this.$parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
        (this.$parent.$parent.getProgramCode() === "evolution" ||
          this.$parent.$parent.getProgramCode() === "regfond")
      ) {
        if (
          spDirectionFinanсing.length > 0 &&
          spDirectionFinanсing[0].CODE &&
          spDirectionFinanсing[0].CODE == "modernization_ship_repair_enterprises"
        ) {
          if (dirItem.CODE == 33) {
            isShowClass = true;
          }
        } else {
          isShowClass = true;
        }
      } else if (
        this.$parent.$parent.getProgramCode() !== "stankostroi" ||
        (this.$parent.$parent.getProgramCode() === "stankostroi" &&
          (dirItem.CODE === 25 ||
            dirItem.CODE === 26 ||
            dirItem.CODE === 23 ||
            dirItem.CODE === 28))
      ) {
        isShowClass = true;
      }

      return isShowClass;
    },
    isShowPodClassByProgram(dirItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowPodClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0) {
            isShowPodClass = true;
          } else if (indistry[0].CODE == 34) {
            if (dirItem.CODE == "32.5") {
              isShowPodClass = true;
            } else {
              isShowPodClass = false;
            }
          } else if (indistry[0].CODE == 36) {
            if (dirItem.CODE == "10.8" || dirItem.CODE == "20.1") {
              isShowPodClass = true;
            } else {
              isShowPodClass = false;
            }
          } else {
            isShowPodClass = true;
          }
        } else {
          isShowPodClass = true;
        }
      } else if (
        this.$parent.$parent.getProgramCode() != "stankostroi" ||
        (this.$parent.$parent.getProgramCode() === "stankostroi" &&
          (dirItem.CODE === 28.4 ||
            dirItem.CODE === 28.2 ||
            dirItem.CODE === 25.7 ||
            dirItem.CODE === 23.9 ||
            dirItem.CODE === 26.5))
      ) {
        isShowPodClass = true;
      }
      return isShowPodClass;
    },
    isShowGroupClassByProgram(dirItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowGroupClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0) {
            isShowGroupClass = true;
          } else if (indistry[0].CODE == 36) {
            if (
              dirItem.CODE == "10.89" ||
              dirItem.CODE == "10.86" ||
              dirItem.CODE == "20.14"
            ) {
              isShowGroupClass = true;
            }
          } else {
            isShowGroupClass = true;
          }
        } else {
          isShowGroupClass = true;
        }
      } else {
        isShowGroupClass = true;
      }
      return isShowGroupClass;
    },
    isShowPodGroupClassByProgram(dirItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowPodGroupClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0) {
            isShowPodGroupClass = true;
          } else if (indistry[0].CODE == 36) {
            if (
              dirItem.CODE == "10.89.1" ||
              dirItem.CODE == "10.86.1" ||
              dirItem.CODE == "20.14.6"
            ) {
              isShowPodGroupClass = true;
            }
          } else {
            isShowPodGroupClass = true;
          }
        } else {
          isShowPodGroupClass = true;
        }
      } else {
        isShowPodGroupClass = true;
      }
      return isShowPodGroupClass;
    },
    isShowVidClassByProgram(dirItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowVidClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0) {
            isShowVidClass = true;
          } else if (indistry[0].CODE == 36) {
            if (
              dirItem.CODE == "10.89.11" ||
              dirItem.CODE == "10.89.19" ||
              dirItem.CODE == "10.86.10" ||
              dirItem.CODE == "20.14.64"
            ) {
              isShowVidClass = true;
            }
          } else {
            isShowVidClass = true;
          }
        } else {
          isShowVidClass = true;
        }
      } else {
        isShowVidClass = true;
      }
      return isShowVidClass;
    },
    isShowCategoriyaByProgram(dirItem, rowItem) {
      if (!this.isMarkerOkpdAllowed(dirItem.CODE)) {
        return false;
      }
      if (this.isMachineToolDirection()) {
        return this.isMachineToolOkpdAllowed(dirItem.CODE);
      }
      let isShowCategoriyaClass = false;

      if (
        this.$parent.$parent.getProgramCode() === "lizing" &&
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.IS_LIMIT_PROFILE_RANGE_OKPD == 1
      ) {
        let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
          c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
        );

        if (
          typeEqupment.length > 0 &&
          typeEqupment[0].CODE == "specialized_manufacturing_industries"
        ) {
          let indistry = this.directory.tree_industry.filter(
            c => c.ID === this.$parent.project.UF_INDUSTRY_ID
          );

          if (indistry.length === 0) {
            isShowCategoriyaClass = true;
          } else if (indistry[0].CODE == 36) {
            let t = this.okpdVidclass(rowItem).filter(
              c => c.ID === rowItem.UF_OKPD_VID_ID
            );
            if (t.length > 0 && t[0].CODE == "10.89.19") {
              if (
                dirItem.CODE == "10.89.19.160" ||
                dirItem.CODE == "10.89.19.210"
              ) {
                isShowCategoriyaClass = true;
              }
            } else {
              isShowCategoriyaClass = true;
            }
          } else {
            isShowCategoriyaClass = true;
          }
        } else {
          isShowCategoriyaClass = true;
        }
      } else {
        isShowCategoriyaClass = true;
      }
      return isShowCategoriyaClass;
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },
    isMarkingOnlyClassCode(code) {
      // Коды первого уровня (класс) ОКПД, доступные только для программы
      // "Маркировка товаров" (внутренний код программы — "lekarstva"): 01, 03, 08.
      // Коды могут приходить числом/строкой/с ведущими нулями, поэтому
      // нормализуем к цифрам без ведущих нулей перед сравнением.
      let norm = String(code)
        .replace(/\D/g, "")
        .replace(/^0+/, "");
      return norm === "1" || norm === "3" || norm === "8";
    },
    isLizingSpecializedManufacturing() {
      if (
        this.$parent.$parent.getProgramCode() !== "lizing" ||
        !this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID ||
        this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID <= 0
      ) {
        return false;
      }
      let typeEqupment = this.directory.sp_purchased_equipment_lizing.filter(
        c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
      );
      return (
        typeEqupment.length > 0 &&
        typeEqupment[0].CODE == "specialized_manufacturing_industries"
      );
    }
  }
};
</script>

<style scoped>
.okpd-products-table {
  table-layout: fixed;
  width: 100%;
}
/* Небольшой отступ блока "Добавить продукцию" от таблицы */
.add-row {
  margin-top: 12px;
}
.okpd-products-table tbody tr.okpd-row-error > td {
  background-color: #fbeaea;
  box-shadow: inset 3px 0 0 0 #d9534f;
}
.okpd-products-table th.okpd-col-num,
.okpd-products-table td.okpd-col-num {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  text-align: center;
  white-space: nowrap;
}
.okpd-products-table th.okpd-col-actions,
.okpd-products-table td.okpd-col-actions {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
  white-space: nowrap;
  text-align: center;
}
.okpd-products-table--readonly th.okpd-col-code,
.okpd-products-table--readonly td.okpd-col-code {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  word-break: break-word;
}
.okpd-products-table--readonly th.okpd-col-list,
.okpd-products-table--readonly td.okpd-col-list {
  width: 280px;
  min-width: 280px;
  word-break: break-word;
}
.okpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0 1px;
  border-radius: 4px;
  text-decoration: none;
  vertical-align: middle;
  transition: background-color 0.15s;
}
.okpd-icon-btn:hover {
  text-decoration: none;
}
.okpd-icon-btn--edit,
.okpd-icon-btn--delete,
.okpd-icon-btn--save,
.okpd-icon-btn--cancel {
  color: #7a8693;
}
.okpd-icon-btn--edit:hover,
.okpd-icon-btn--delete:hover,
.okpd-icon-btn--save:hover,
.okpd-icon-btn--cancel:hover {
  background-color: #eef1f4;
  color: #394a5a;
}
</style>